export default (originalValue, newValue) => {
  // console.log('originalValue', originalValue, 'newValue', newValue);
  if (Array.isArray(originalValue) && Array.isArray(newValue)
    && originalValue.length === newValue.length
  ) return false;
  if (newValue === '' && originalValue === undefined) return false;
  if (newValue === '' && originalValue === null) return false;
  if (!newValue && !originalValue) return false;
  return originalValue !== newValue;
}
